import React from 'react'
import { Modal } from 'react-bootstrap'
import './modal.css'

function CustomModal(props) {
   const {
      show,
      children,
      footerComponent,
      title,
      closeModal,
      loading,
      subTitle,
      closeButton = true,
      ...rest
   } = props

   return (
      <Modal show={show} onHide={closeModal} {...rest}>
         <Modal.Header
            className={`${loading ? 'hide-close-btn' : ''}`}
            closeButton={closeButton}
            closeVariant="white">
            {title && (
               <div>
                  <h5 className="modal-title at-text-dark">{title}</h5>
                  {subTitle && <span className="at-text-light">{subTitle}</span>}
               </div>
            )}
         </Modal.Header>
         <Modal.Body>{children}</Modal.Body>
         {footerComponent && <Modal.Footer>{footerComponent}</Modal.Footer>}
      </Modal>
   )
}

export default CustomModal
